// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const TitleIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="TitleIcon" ref={forwardedRef} {...props}>
      <path d="M16 4H4v1.5h5.25V17h1.5V5.5H16z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const TitleIcon = /* @__PURE__ */ Object.assign(TitleIconComponent, {
  displayName: 'TitleIcon',
});
